/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../../types/schema.generated';

import gql from 'graphql-tag';
export type SortCalendarSummaryFunctionCalendarSummaryFragment = { createdAt: TimeString };

export const SortCalendarSummaryFunctionCalendarSummaryFragmentDoc = gql`
    fragment SortCalendarSummaryFunctionCalendarSummary on CalendarSummary {
  createdAt
}
    `;